export const AQUIFER_NAME_MAP = Object.freeze({
    30101: "Palolo",
    30102: "Nuuanu",
    30103: "Kalihi",
    30104: "Moanalua",
    30105: "Waialae-West",
    30106: "Waialae-East",
    30201: "Waimalu",
    30203: "Waipahu-Waiawa",
    30204: "Ewa-Kunia",
    30205: "Makaiwa",
    30301: "Nanakuli",
    30302: "Lualualei",
    30303: "Waianae",
    30304: "Makaha",
    30305: "Keaau",
    30401: "Mokuleia",
    30402: "Waialua",
    30403: "Kawailoa",
    30501: "Wahiawa",
    30601: "Koolauloa",
    30602: "Kahana",
    30603: "Koolaupoko",
    30604: "Waimanalo",
    30701: "Ford Island",
    30702: "Sand Island",
});

export const AQUIFER_CODE_MAP = Object.freeze({
    "Palolo": 30101,
    "Nuuanu": 30102,
    "Kalihi": 30103,
    "Moanalua": 30104,
    "Waialae-West": 30105,
    "Waialae-East": 30106,
    "Waimalu": 30201,
    "Waipahu-Waiawa": 30203,
    "Ewa-Kunia": 30204,
    "Makaiwa": 30205,
    "Nanakuli": 30301,
    "Lualualei": 30302,
    "Waianae": 30303,
    "Makaha": 30304,
    "Keaau": 30305,
    "Mokuleia": 30401,
    "Waialua": 30402,
    "Kawailoa": 30403,
    "Wahiawa":30501,
    "Koolauloa": 30601,
    "Kahana": 30602,
    "Koolaupoko": 30603,
    "Waimanalo": 30604,
    "Ford Island": 30701,
    "Sand Island": 30702,
});